// Swedish/Finnish coffee brewing ratio
// Standard ratio: 60g coffee per 1000ml water (6g per 100ml)
export const DEFAULT_RATIO = 0.06; // coffee grams / water ml

// Roast level affects ideal brew ratio:
// Light roast: denser beans, need more coffee for full extraction
// Medium roast: standard Nordic ratio
// Dark roast: more porous, extracts easier, needs less coffee
export type RoastLevel = "light" | "medium" | "dark";

export const ROAST_RATIOS: Record<RoastLevel, number> = {
  light: 0.065,
  medium: 0.06,
  dark: 0.055,
} as const;

export function calculateWater(coffeeGrams: number, ratio: number = DEFAULT_RATIO): number {
  if (coffeeGrams <= 0) return 0;
  return Math.round(coffeeGrams / ratio);
}

export function calculateCoffee(waterMl: number, ratio: number = DEFAULT_RATIO): number {
  if (waterMl <= 0) return 0;
  return Math.round(waterMl * ratio);
}

// Common cup sizes in ml
export const CUP_SIZES = {
  small: 150,
  medium: 200,
  large: 250,
  mug: 300,
} as const;

export function calculateCups(waterMl: number, cupSize: number = CUP_SIZES.medium): number {
  if (waterMl <= 0) return 0;
  return Math.round((waterMl / cupSize) * 10) / 10;
}
